var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAttention(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4412",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    d: "M30.2,47.9c.8,0,1.6-.3,2.2-.9.6-.6.9-1.4.9-2.2,0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.8,0-1.6.3-2.2.9-.6.6-.9,1.4-.9,2.2,0,.8.3,1.6.9,2.2.6.6,1.4.9,2.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    d: "M30.2,36.6c.8,0,1.6-.3,2.2-.9.6-.6.9-1.4.9-2.2v-16.7c0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.8,0-1.6.3-2.2.9-.6.6-.9,1.4-.9,2.2v16.7c0,.8.3,1.6.9,2.2.6.6,1.4.9,2.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    d: "M28.1,0c25.2-1.6,41,26.9,26.2,47.5-9.7,13.4-28.5,16.5-41.9,6.7-2.3-1.7-4.4-3.7-6.2-6C-8.4,29.2,4.3,1.6,28.1,0M27.9,4.3C10.3,5.6-.7,24.4,6.4,40.6c8.6,19.3,35.8,20.6,46,2.1C62.6,24.5,48.4,2.9,27.9,4.3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/icon_attention.e2e06c7d88a3f848fa626cfd29edf97d.svg";
export { ForwardRef as ReactComponent };